module.exports = __webpack_public_path__ + "static/media/RoundedRect_Green@3x.1f46752b.png";